<template>
    <div>
        <div v-if="item.violation && item.customer.price">
            <span>
                {{ $filters.priceFormat(item.customer.price.amount, item.customer.price.currency) }}
            </span>
            <span>
                <corporate-policy-violation :policies="item.corporatePolicies" />
            </span>
        </div>
        <span v-else>
            {{ $filters.priceFormat(item.customer.price.amount, item.customer.price.currency) }}
            <v-tooltip
                v-if="
                    item.customerPenaltyStatus &&
                    item.customerPenaltiesTooltip &&
                    $conf.public.account.showCustomerPenaltiesTooltip
                "
                location="top"
            >
                <template v-slot:activator="{props}">
                    <v-icon :color="item.customerPenaltyStatus" size="small" v-bind="props">
                        {{ item.customerPenaltyStatus === 'red' ? 'mdi-cloud-remove' : 'mdi-message-alert' }}
                    </v-icon>
                </template>
                <span>{{ item.customerPenaltiesTooltip }}</span>
            </v-tooltip>
        </span>
        <template v-if="(isAgency || isTourOperator) && item.customer.price.commission && commissionAndNettoCheckbox">
            <div class="commission text-grey">
                {{ $t('commission') }}:
                {{ $filters.priceFormat(item.customer.price.commission, item.customer.price.currency) }}
            </div>
            <div class="commission text-grey">
                {{ $t('net_amount') }}:
                {{
                    $filters.priceFormat(
                        item.customer.price.amount - item.customer.price.commission,
                        item.customer.price.currency
                    )
                }}
            </div>
        </template>
        <payment-status-label
            v-if="showPaymentStatus && !$conf.public.account.paymentScheduler"
            :status="item.customer.paymentStatus"
            class="text-no-wrap"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import PaymentStatusLabel from '~src/components/account/snippets/paymentStatusLabel.src'
    import CorporatePolicyViolation from '~/components/snippets/CorporatePolicyViolation.vue'

    @Component({
        components: {
            PaymentStatusLabel,
            CorporatePolicyViolation,
        },
    })
    export class OrdersPriceLabel extends Vue {
        @Prop({required: true}) item
        @Prop({default: true, type: Boolean}) showPaymentStatus

        get isTourOperator() {
            return authStore.isTourOperator
        }

        get isAgency() {
            return authStore.isAgency
        }

        get commissionAndNettoCheckbox() {
            return persistentStore.commissionAndNettoCheckbox
        }
    }

    export default OrdersPriceLabel
</script>

<style scoped lang="scss">
    .commission {
        font-size: 10px;
    }
</style>
